import script from "./ServerError.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerError.vue?vue&type=script&setup=true&lang=js"

import "./ServerError.vue?vue&type=style&index=0&id=6fac12f2&lang=css"

const __exports__ = script;

export default __exports__